/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'
import PagesRouterAppGlobals from './pages-router'
import AppRouterAppGlobals from './app-router'

export { AppRouterAppGlobals }
export default PagesRouterAppGlobals
